<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="rocket"/>
          {{$t('smsCampaign')}}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="filterFormModel.status" @input="load">
          <b-tab :title="$t('all')"></b-tab>
          <b-tab :title="$t('draft')"></b-tab>
          <b-tab :title="$t('started')"></b-tab>
          <b-tab :title="$t('sending')"></b-tab>
          <b-tab :title="$t('finished')"></b-tab>
        </b-tabs>
        <div class="tile">
          <div class="form-inline">
            <client-select :model="filterFormModel" attribute="client" class="mr-1 mb-1" @input="load"></client-select>
            <form-select :model="filterFormModel" attribute="type" class="mr-1 mb-1" :options="[
                {value: null, text: $t('all')},
                {value: 'ads', text: $t('ads')},
                {value: 'care', text: $t('care')}
            ]"></form-select>
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')"></b-form-input>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-4">{{ $t('info') }}</div>
            <div class="col-lg-4">{{ $t('status') }}</div>
            <div class="col-lg-2">{{ $t('result') }}</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-4">
              <p v-if="item.client.companyName"><b>{{$t('companyName')}}</b>: <span> {{item.client.companyName}} </span></p>
              <p><b>{{$t('domain')}}: </b><span>{{ item.client.domain }}</span></p>
              <p><b>{{ $t('name') }}: </b><span>{{ item.name }}</span></p>
              <p>
                <b>{{ $t('type') }}: </b>
                <label v-if="item.type==='ads'" class="badge badge-warning">{{ $t('ads') }}</label>
                <label v-if="item.type==='care'" class="badge badge-info">{{ $t('care') }}</label>
              </p>
              <p v-if="item.adsId"><b>Ads id: </b>{{item.adsId}}</p>
            </div>
            <div class="col-lg-4">
              <p>
                <label v-if="item.finishTime" class="badge badge-success">{{$t('finished')}}</label>
                <label v-if="item.type === 'ads' && item.confirmTime && !item.finishTime" class="badge badge-warning">{{$t('sending')}}</label>
                <label v-if="item.type === 'ads' && item.startTime && !item.confirmTime && !item.finishTime" class="badge badge-danger">{{$t('started')}}</label>
                <label v-if="item.type ==='care' && item.startTime && !item.finishTime" class="badge badge-warning">{{$t('sending')}}</label>
                <label v-if="!item.startTime" class="badge badge-secondary">{{$t('draft')}}</label>
              </p>
              <p><b>{{$t('createTime')}}: </b><span>{{item.createTime | moment('DD/MM/YYYY HH:mm')}}</span></p>
              <p v-if="item.startTime"><b>{{$t('startTime')}}: </b><span>{{item.startTime | moment('DD/MM/YYYY HH:mm')}}</span></p>
              <p v-if="item.confirmTime"><b>{{$t('confirmTime')}}: </b><span>{{item.confirmTime | moment('DD/MM/YYYY HH:mm')}}</span></p>
              <p v-if="item.finishTime"><b>{{$t('finishTime')}}: </b><span>{{item.finishTime | moment('DD/MM/YYYY HH:mm')}}</span></p>
              <p v-if="item.confirmedBy"><b>{{$t('confirmedBy')}}: </b><span>{{item.confirmedBy.name}}</span></p>
            </div>
            <div class="col-lg-2">
              <p>
                <b>{{$t('total')}}: </b>
                <b-spinner v-if="resultLoading" small></b-spinner>
                <span v-else-if="smss[item._id]">{{smss[item._id].total | numFormat}}</span>
                <span v-else>0</span>
              </p>
              <p>
                <b>{{$t('success')}}: </b>
                <b-spinner v-if="resultLoading" small></b-spinner>
                <span v-else-if="smss[item._id]">{{smss[item._id].total - smss[item._id].sending - smss[item._id].failure| numFormat}}</span>
                <span v-else>0</span>
              </p>
              <p>
                <b>{{$t('sending')}}: </b>
                <b-spinner v-if="resultLoading" small></b-spinner>
                <span v-else-if="smss[item._id]">{{smss[item._id].sending | numFormat}}</span>
                <span v-else>0</span>
              </p>
              <p>
                <b>{{$t('error')}}: </b>
                <b-spinner v-if="resultLoading" small></b-spinner>
                <span v-else-if="smss[item._id]">{{smss[item._id].failure| numFormat}}</span>
                <span v-else>0</span>
              </p>
            </div>
            <div class="col-lg-2">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col">
                    <button @click="del(item._id)" type="button" class="btn btn-sm btn-danger mr-1" v-if="!item.startTime">
                      <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
  </main>
</template>

<script>
import List from '../../mixins/List';
import CRUD from "../../mixins/CRUD";
import ClientSelect from "../../components/ClientSelect";
// import SMSCampaignAddFailedContact from "./SMSCampaignAddFailedContact";
// import SMSCampaignUploadFailedContacts from "./SMSCampaignUploadFailedContacts";

export default {
  components: {ClientSelect},
  mixins: [List, CRUD],
  data: function () {
    return {
      service: '/sms-campaign',
      defaultFilterFormModel: {
        keyword: null,
        type: null
      },
      resultLoading: false,
      smss: {},
      afterLoad(){
        this.getResults();
      },
    }
  },
  mounted() {
    this.$bus.$on('loadSMSCampaign', this.load);
  },
  destroyed() {
    this.$bus.$off('loadSMSCampaign', this.load);
  },
  methods: {
    getResults() {
      this.resultLoading = true;
      let ids = this.items.map(item => {
        return item._id;
      })
      if (ids && ids.length) {
        this.$service.post(this.service + "/contact-count", {ids: ids}).then(response => {
          this.smss = {};
          response.data.forEach(item => {
            this.smss[item._id] = item;
          });
        }).finally(() => {
          this.resultLoading = false;
        });
      }
    },
    rollBack: function (id) {
      this.$swal({
        title: this.$t('adsCampaignRollBackConfirm'),
        icon: "info",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          let loader = this.$loading.show();
          this.$service.put(this.service + '/roll-back/' + id).then(response => {
            if (response.data) {
              this.load();
              this.$swal({
                title: this.$t('rollBackSuccess'),
                icon: 'success',
                toast: true,
                position: 'top-end',
                timer: 5000,
              });
            } else {
              this.$swal({
                title: this.$t('error'),
                text: this.$t('rollBackFailed'),
                icon: 'error'
              });
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            }
          }).finally(() => {
            loader.hide();
          });
        }
      });
    },
    confirm: function (id) {
      this.$swal({
        title: this.$t('adsCampaignConfirmConfirm'),
        icon: "info",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          let loader = this.$loading.show();
          this.$service.put(this.service + '/confirm/' + id).then(response => {
            if (response.data) {
              this.load();
              this.$swal({
                title: this.$t('confirmSuccess'),
                icon: 'success',
                toast: true,
                position: 'top-end',
                timer: 5000,
              });
            } else {
              this.$swal({
                title: this.$t('error'),
                text: this.$t('confirmFailed'),
                icon: 'error'
              });
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            }
          }).finally(() => {
            loader.hide();
          });
        }
      });
    },
    finish: function (id) {
      this.$swal({
        title: this.$t('campaignFinishConfirm'),
        icon: "info",
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          let loader = this.$loading.show();
          this.$service.put(this.service + '/finish/' + id).then(response => {
            if (response.data) {
              this.load();
              this.$swal({
                title: this.$t('finishSuccess'),
                icon: 'success',
                toast: true,
                position: 'top-end',
                timer: 5000,
              });
            } else {
              this.$swal({
                title: this.$t('error'),
                text: this.$t('finishFailed'),
                icon: 'error'
              });
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            }
          }).finally(() => {
            loader.hide();
          });
        }
      });
    },
  },
  i18n: {
    messages: {
      en: {
        smsCampaign: 'SMS campaign',
        ads: 'Ads',
        care: 'Care',
        draft: 'Draft',
        started: 'Started',
        sending: 'Sending',
        finished: 'Finished',
        companyName: 'Company name',
        info: 'Campaign info',
        status: 'Status',
        result: 'Result',
        createTime: 'Create time',
        startTime: 'Start time',
        confirmTime: 'Confirm time',
        finishTime: 'Finish time',
        confirmedBy: 'Confirmed by',
        type: 'Campaign type',
        adsCampaignConfirmConfirm: 'Are you sure to confirm this ads campaign?',
        confirmSuccess: "Campaign confirmed!",
        confirm: 'Confirm',
        finish: 'Finish',
        finishSuccess: 'Campaign finished!',
        finishFailed: 'Campaign finished failed!',
        campaignFinishConfirm: 'Are you sure to finish this campaign?',
        rollBack: 'Roll back',
        adsCampaignRollBackConfirm: 'Are you sure to roll back this campaign',
        rollBackSuccess: 'Campaign rolled back!',
        rollBackFailed: 'Fail to roll back'
      },
      vi: {
        smsCampaign: 'Chiến dịch SMS',
        ads: 'Quảng cáo',
        care: 'CSKH',
        draft: 'Nháp',
        started: 'Đã bắt đầu',
        sending: 'Đang gửi',
        finished: 'Đã kết thúc',
        companyName: 'Tên KH',
        info: 'Thông tin chiến dịch',
        status: 'Trạng thái',
        result: 'Kết quả',
        createTime: 'Tạo lúc',
        startTime: 'Bắt đầu lúc',
        confirmTime: 'Xác nhận lúc',
        finishTime: 'Hoàn thành lúc',
        confirmedBy: 'Xác nhận bởi',
        type: 'Loại chiến dịch',
        adsCampaignConfirmConfirm: 'Bạn có chắc muốn xác nhận gửi tin chiến dịch quảng cáo này?',
        confirmSuccess: "Chiến dịch đã được xác nhận!",
        confirm: 'Xác nhận',
        finish: 'Hoàn thành',
        finishSuccess: 'Chiến dịch đã hoàn thành!',
        finishFailed: 'Có lỗi xảy ra! Chiến dịch chưa hoàn thành!',
        campaignFinishConfirm: 'Bạn có chắc muốn hoàn thành chiến dịch này?',
        rollBack: 'Quay lại',
        adsCampaignRollBackConfirm: 'Bạn có chắc muốn roll back chiến dịch này?',
        rollBackSuccess: 'Chiến dịch đã được roll back',
        rollBackFailed: 'Roll back thất bại'
      }
    }
  },
};
</script>